<template>
    <fragment>
        <slot v-if="isOnline" name="online"></slot>
        <slot v-if="isOffline" name="offline"></slot>
    </fragment>
</template>

<script>
    export default {
        name: "OnlineOffline"
    }
</script>

<style scoped>

</style>